import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BaseLocationService } from './base-location.service';

export type OgImage = {
  elements: [HTMLMetaElement] | [HTMLMetaElement, HTMLMetaElement];
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class OgImageService {

  private meta = inject(Meta);
  private baseLocation = inject(BaseLocationService);
  private images = new Set<string>();

  public add(url: string, alt?: string): OgImage | undefined {
    if (this.images.has(url)) {
      return undefined;
    }
    this.images.add(url);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const imageMetaElement = this.meta.addTag({ name: 'og:image', content: `${this.baseLocation.origin}${url}` }, true)!;

    if (alt) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const altMetaElement = this.meta.addTag({ name: 'og:image:alt', content: alt }, true)!;
      return {
        elements: [imageMetaElement, altMetaElement],
        url: url,
      };
    }

    return {
      elements: [imageMetaElement],
      url: url,
    };
  }

  public remove(result: OgImage) : void {
    result.elements.forEach((metaTag) => this.meta.removeTagElement(metaTag));
    this.images.delete(result.url);
  }

}
